module.exports = __webpack_public_path__ + "static/img7-5567168e99080af0c448dcf564989e09.jpg";